import React from 'react'
import styled from 'styled-components'
import { Link } from '@nv/react-akira'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { ROUTES } from 'containers/Base/constants'
import { FormattedMessage } from 'react-intl'
import { Formik, Form } from 'formik'
import { LOGIN_WITH_EMAIL_SCHEMA } from './LoginForm.constants'
import { TextInputField } from 'components/TextInputField'
import { SubmitButton } from 'components/SubmitButton'
import { DASH_ERRORS } from 'constants/errors'
import { useDispatch } from 'react-redux'
import { PersistFormikValues } from 'formik-persist-values'
import { useToast } from 'hooks'
import { login } from 'utils/auth'

export const EmailLogin = () => {
  const dispatch = useDispatch()
  const { showError } = useToast()
  const navigate = useNavigate()

  return (
    <Formik
      initialValues={{
        email: '',
        password: ''
      }}
      validationSchema={LOGIN_WITH_EMAIL_SCHEMA}
      onSubmit={async (values, { setErrors }) => {
        const castedValues = LOGIN_WITH_EMAIL_SCHEMA.cast(values)
        const response = await login({ navigate, dispatch, email: castedValues as { email: string; password: string } })

        if (!response.ok) {
          const { code, message } = response?.data?.error || {}

          if (code === DASH_ERRORS.WRONG_CREDENTIALS) {
            setErrors({ email: 'types.error.wrong_username_or_password' })
            return
          }

          if (
            code === DASH_ERRORS.FORBIDDEN &&
            message.includes('mobile shipper from non-unified trying to login to web api')
          ) {
            showError({
              code,
              customErrors: {
                [DASH_ERRORS.FORBIDDEN]: 'types.error.forbidden_cross_platform_login'
              }
            })
            return
          } else {
            showError({ code })
          }

          return
        }
      }}
    >
      <FormWrapper>
        <TextInputField name='email' label={<FormattedMessage id='email_address' />} />
        <TextInputField type='password' name='password' label={<FormattedMessage id='password' />} />

        <ForgotPasswordTextWrapper>
          <Link as={RouterLink} to={ROUTES.UNIFIED_FORGOT_PASSWORD}>
            <FormattedMessage id='forgot_your_password' />
          </Link>
        </ForgotPasswordTextWrapper>

        <SubmitButton>
          <FormattedMessage id='login' />
        </SubmitButton>

        <PersistFormikValues name='login-email-form' storage='sessionStorage' />
      </FormWrapper>
    </Formik>
  )
}

const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
`

const ForgotPasswordTextWrapper = styled.div`
  margin-top: -8px;
  margin-bottom: 12px;
  display: flex;
  justify-content: end;
`
